import React from "react";
import { assetUrl } from "../../functions/themeAssets";

/** Banner of challenge n: the PNG the admin uploaded, else the bundled one. */
export function bannerSrc(theme, n) {
  const custom = theme && theme[`challenge_image_${n}`];
  return custom ? assetUrl(custom) : `${process.env.PUBLIC_URL || ""}/img/bp/layer${n}.png`;
}

/** The small inline icons the original pages drew (clock, star, send). */
const ICONS = {
  clock: "M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm.5-13H11v6l4.7 2.8.8-1.3-4-2.4Z",
  star: "m12 17.27 6.18 3.73-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21Z",
  send: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z",
  trophy: "M6 3h12v3h3v2c0 2.8-2 5-4.6 5.4A5 5 0 0 1 13 15.9V18h3v3H8v-3h3v-2.1A5 5 0 0 1 7.6 13.4C5 13 3 10.8 3 8V6h3zm0 5H5c0 1.3.8 2.4 2 2.8A9 9 0 0 1 6 8zm12 0c0 .9-.1 1.9-.4 2.8 1.2-.4 2-1.5 2-2.8z",
};

export function Icon({ name }) {
  return (
    <span className={`tf-icon tf-icon-${name}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d={ICONS[name]} />
      </svg>
    </span>
  );
}

/** Timer pill – challenge banner – points pill, shown at the top of every challenge. */
export function StageHeader({ clock, points, src, alt }) {
  return (
    <header className="tf-header">
      <div className="tf-pill tf-timer-pill" aria-label="Elapsed time">
        <Icon name="clock" />
        <span id="timer-display">{clock}</span>
      </div>

      <div className="tf-challenge-banner">
        <img src={src} alt={alt} />
      </div>

      <div className="tf-pill tf-points-pill" aria-label="Points">
        <Icon name="star" />
        <span id="points">{points}</span>
      </div>
    </header>
  );
}

export function SubmitButton({ disabled }) {
  return (
    <div className="tf-submit-wrap">
      <button type="submit" name="Submit" className="tf-submit-btn" disabled={disabled}>
        SUBMIT <Icon name="send" />
      </button>
    </div>
  );
}

export function Loader() {
  return (
    <div className="st-loader">
      <div className="st-loader-spinner" />
    </div>
  );
}

/** Asks phones to be held upright (the PHP login page did this). */
export const isMobileDevice = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
